// extracted by mini-css-extract-plugin
export default {"dndArea":"DndArea_dndArea__zRQ9L"};